import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Minimal shared-state service for animation playback.
 * Allows FramesTimeline to broadcast play/stop state to Frames component
 * so Frames can switch to instant scroll during playback (preventing jitter).
 */
@Injectable({ providedIn: 'root' })
export class PlaybackService {
  isPlaying$ = new BehaviorSubject<boolean>(false);

  setPlaying(v: boolean): void {
    this.isPlaying$.next(v);
  }
}
